import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IDocumentTemplate } from "../../utils/types/models";

export default createEntityReducer<IDocumentTemplate>(Endpoint.DocumentTemplates, Endpoint.DocumentTemplatesList);
